import { useQuery } from "@tanstack/react-query"
import { getAdminCompanyDetails } from "@/lib/api/admin-company.api"
import { useAuthStore } from "@/store/auth.store"

export function useGetAdminCompanyDetails(id?: string) {
  const { accessToken } = useAuthStore()

  return useQuery({
    queryKey: ["admin-company-details", id],
    queryFn: async () => {
      if (!accessToken) throw new Error("No access token")
      if (!id) throw new Error("No company ID provided")
      const response = await getAdminCompanyDetails(id, accessToken)
      if (!response.success) throw new Error(response.message)
      return response.data
    },
    enabled: !!accessToken && !!id,
  })
}
